import React from 'react';
import styled from 'styled-components';

const DividerElement = styled.div<{ $height: number }>`
  background-color: ${({ theme }) => theme.colors.background.gray};
  margin-block: ${({ $height }) => $height}rem;
  height: 2px;
`;

interface Props {
  height?: number;
}

const Divider = ({ height = 1 }: Props) => {
  return <DividerElement $height={height} />;
};

export default Divider;
